import type { TableCell } from '~/components/ui/table/Table';
import { formatPhoneNumber } from '~/components/ui/inputs/phoneNumber';
import { formatDateTime } from '~/utils';

export const EMPTY_CELL = '—';

type UserWithLastEdit = {
  phoneNumber?: string | null;
  lastEditedAt?: string | null;
  lastEditedBy?: { firstName: string; lastName: string } | null;
};

export function userPhoneAndLastEditCells({
  phoneNumber,
  lastEditedAt,
  lastEditedBy,
}: UserWithLastEdit): Record<
  'phoneNumber' | 'lastEditedBy' | 'lastEditedAt',
  TableCell
> {
  return {
    phoneNumber: {
      value: phoneNumber ? formatPhoneNumber(phoneNumber) : EMPTY_CELL,
    },
    lastEditedBy: {
      value: lastEditedBy
        ? `${lastEditedBy.firstName} ${lastEditedBy.lastName}`
        : EMPTY_CELL,
    },
    lastEditedAt: {
      value: lastEditedAt ? formatDateTime(lastEditedAt) : EMPTY_CELL,
    },
  };
}
